<template>
  <main class="site__main">
    <div>
      <fieldset ref="afterRewrite">
        <first-message
          :form-count="formCount"
          @end-first-message="openForm"
        ></first-message>
        <form-hope-work-timing
          v-if="show.hopeWorkTiming"
          @form-fix-hope-work-timing="fixHopeWorkTiming"
          @form-next="setHopeWorkTimingAfterForm"
        ></form-hope-work-timing>
        <form-pref-and-workplace
          v-if="show.prefAndWorkplace"
          @form-fix-pref="fixPref"
          @form-fix-workplace="fixWorkplace"
          @form-next="setPrefAndWorkplaceAfterForm"
          @form-change-pref="changePref"
          @form-change-workplace="changeWorkplace"
        ></form-pref-and-workplace>
        <form-now-status-and-career
          v-if="show.nowStatusAndCareer"
          @form-fix-now-status="fixNowStatus"
          @form-fix-full-time-worker-period="fixFullTimeWorkerPeriod"
          @form-fix-career="fixCareer"
          @form-next="setNowStatusAndCareerAfterForm"
          @form-change-now-status="changeNowStatus"
          @form-change-full-time-worker-period="changeFullTimeWorkerPeriod"
          @form-change-career="changeCareer"
        ></form-now-status-and-career>
        <form-birthday-and-gender
          v-if="show.birthdayAndGender"
          @form-fix-birthday-and-gender="fixBirthdayAndGender"
          @form-next="setBirthdayAndGenderAfterForm"
          @form-change-birthday-and-gender="changeBirthdayAndGender"
        ></form-birthday-and-gender>
        <form-name-and-tel-and-mail
          v-if="show.nameAndTelAndMail"
          @form-fix-name="fixName"
          @form-fix-tel-and-mail="fixTelAndMail"
          @form-next="setNameAndTelAndMailAfterForm"
          @form-change-name="changeName"
          @form-change-tel-and-mail="changeTelAndMail"
        ></form-name-and-tel-and-mail>
        <form-password
          v-if="show.password"
          @form-fix-password="fixPassword"
          @form-next="setPasswordAfterForm"
          @form-change-password="changePassword"
        ></form-password>
        <form-submit-button
          v-if="show.submitbutton"
          :form-data="formData"
          @form-submit="sendKairosForm"
          @form-error="getErrorResponse"
        ></form-submit-button>
        <form-kairos v-show="show.kairos" :customer="formData" :do-submit="isKairos"></form-kairos>
        <form-error v-if="show.error" :message="error.message"></form-error>
      </fieldset>
    </div>
  </main>
</template>

<script>
import constMixin from '../mixins/ConstMixin'
import FirstMessage from './forms/FirstMessage'
import FormHopeWorkTiming from './forms/FormHopeWorkTiming'
import FormPrefAndWorkplace from './forms/FormPrefAndWorkplace'
import FormNowStatusAndCareer from './forms/FormNowStatusAndCareer'
import FormBirthdayAndGender from './forms/FormBirthdayAndGender'
import FormNameAndTelAndMail from './forms/FormNameAndTelAndMail'
import FormPassword from './forms/FormPassword'
import FormSubmitButton from './forms/FormSubmitButton'
import FormKairos from './forms/FormKairos'
import FormRewriteEmail from './forms/FormRewriteEmail'
import FormError from './forms/FormError'
import Vue from 'vue'

export default {
  name: 'ChatContents',
  mixins: [constMixin],
  components: {
    FirstMessage,
    FormHopeWorkTiming,
    FormPrefAndWorkplace,
    FormNowStatusAndCareer,
    FormBirthdayAndGender,
    FormNameAndTelAndMail,
    FormPassword,
    FormSubmitButton,
    FormKairos,
    FormRewriteEmail,
    FormError
  },
  props: {
    formCount: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      show: {
        hopeWorkTiming: false,
        prefAndWorkplace: false,
        nowStatusAndCareer: false,
        birthdayAndGender: false,
        nameAndTelAndMail: false,
        password: false,
        submitbutton: false,
        kairos: false,
        error: false
      },
      formData: {
        step: null,
        render: null,
        referer: null,
        lp_type: null,
        pref: null,
        workplace: null,
        hope_work_timing: null,
        full_time_worker_period: null,
        now_status: null,
        career: null,
        birth_year: null,
        birth_month: null,
        birth_day: null,
        sex: null,
        name_sei: null,
        name_mei: null,
        kana_sei: null,
        kana_mei: null,
        tel1: null,
        tel2: null,
        tel3: null,
        email: null,
        password: null
      },
      error: {
        message: null
      },
      customer: {},
      isKairos: false
    }
  },
  created: function () {
    this.formData.step = this.constForm.step
    this.formData.render = this.constForm.render
    // this.formData.referer = this.constForm.referer
    this.formData.lp_type = this.constForm.lp_type
  },
  mounted: function () {
    // console.log(this.$refs.kairosForm)
    // if (document.getElementById('daini_s-form')) {
    //   if (document.getElementById('daini_s-form').dataset.referrer) {
    //     this.formData.referer = Number(document.getElementById('daini_s-form').dataset.referrer)
    //   }
    // }
    this.setReferer()
  },
  methods: {
    setReferer: function () {
      let referrer = this.constForm.referer
      const url = new URL(window.location.href)
      const params = url.searchParams
      const paramReferrer = params.get('referrer')
      const utmSource = params.get('utm_source')
      const utmCampaign = params.get('utm_campaign')
      if (utmSource !== null) {
        switch (utmSource) {
          case 'vc':
            referrer = 3
            break
          case 'facebook':
            referrer = 4
            break
          case 'hr-note':
            referrer = 6
            break
          case 'line':
            referrer = 10
            break
          case 'instagram':
            referrer = 13
            break
          case 'interspace':
            referrer = 15
            break
          case 'tosho':
            referrer = 18
            break
          case 'presco':
            referrer = 19
            break
          case 'dandm':
            referrer = 20
            break
          case 'rentracks':
            referrer = 21
            break
          case 'a8':
            referrer = 22
            break
          case 'reabroad':
            referrer = 23
            break
          case 'unoteme':
            referrer = 25
            break
          case 'referral':
            referrer = 26
            break
          case 'bgt':
            referrer = 27
            break
          case 'afb':
            referrer = 28
            break
          case 'new1':
            referrer = 29
            break
          case 'new2':
            referrer = 30
            break
          case 'new3':
            referrer = 31
            break
          case 'new4':
            referrer = 32
            break
          case 'new5':
            referrer = 33
            break
          case 'new6':
            referrer = 34
            break
          case 'new7':
            referrer = 35
            break
          case 'new8':
            referrer = 36
            break
          case 'new9':
            referrer = 37
            break
          case 'new10':
            referrer = 38
            break
          case 'new11':
            referrer = 39
            break
          case 'new12':
            referrer = 40
            break
          case 'new13':
            referrer = 41
            break
          case 'new14':
            referrer = 42
            break
          case 'new15':
            referrer = 43
            break
          case 'new16':
            referrer = 44
            break
          case 'new17':
            referrer = 45
            break
          case 'new18':
            referrer = 46
            break
          case 'new19':
            referrer = 47
            break
          case 'new20':
            referrer = 48
            break
          case 'new21':
            referrer = 49
            break
          case 'new22':
            referrer = 50
            break
          case 'new23':
            referrer = 51
            break
          case 'new24':
            referrer = 52
            break
          case 'new25':
            referrer = 53
            break
          case 'new26':
            referrer = 54
            break
          case 'new27':
            referrer = 55
            break
          case 'new28':
            referrer = 56
            break
          case 'new29':
            referrer = 57
            break
          case 'new30':
            referrer = 58
            break
          case 'new31':
            referrer = 59
            break
          case 'new32':
            referrer = 60
            break
          case 'new33':
            referrer = 61
            break
          case 'new34':
            referrer = 62
            break
          case 'new35':
            referrer = 63
            break
          case 'new36':
            referrer = 64
            break
          case 'new37':
            referrer = 65
            break
          case 'new38':
            referrer = 66
            break
          case 'new39':
            referrer = 67
            break
          case 'new40':
            referrer = 68
            break
          case 'new41':
            referrer = 69
            break
          case 'new42':
            referrer = 70
            break
          case 'new43':
            referrer = 71
            break
          case 'new44':
            referrer = 72
            break
          case 'new45':
            referrer = 73
            break
          case 'new46':
            referrer = 74
            break
          case 'new47':
            referrer = 75
            break
          case 'new48':
            referrer = 76
            break
          case 'new49':
            referrer = 77
            break
          case 'new50':
            referrer = 78
            break
          case 'new51':
            referrer = 79
            break
          case 'new52':
            referrer = 80
            break
          case 'new53':
            referrer = 81
            break
          case 'new54':
            referrer = 82
            break
          case 'new55':
            referrer = 83
            break
          case 'new56':
            referrer = 84
            break
          case 'new57':
            referrer = 85
            break
          case 'new58':
            referrer = 86
            break
          case 'new59':
            referrer = 87
            break
          default:
            if (utmCampaign !== null) {
              switch (utmCampaign) {
                case 'scout':
                  referrer = 2
                  break
                case 'referral':
                  referrer = 26
                  break
              }
            }
        }
      } else if (utmCampaign !== null) {
        switch (utmCampaign) {
          case 'scout':
            referrer = 2
            break
          case 'referral':
            referrer = 26
            break
        }
      } else if (paramReferrer !== null) {
        referrer = paramReferrer
      }
      if (referrer === this.constForm.referer) {
        if (document.getElementById('daini_s-form')) {
          if (document.getElementById('daini_s-form').dataset.referrer) {
            referrer = Number(document.getElementById('daini_s-form').dataset.referrer)
          }
        }
      }
      this.formData.referer = Number(referrer)
    },
    openForm: function () {
      this.show.hopeWorkTiming = true
    },
    fixHopeWorkTiming: function (hopeWorkTiming) {
      this.formData.hope_work_timing = hopeWorkTiming
      this.$emit('form-countup')
    },
    setHopeWorkTimingAfterForm: function () {
      this.show.prefAndWorkplace = true
    },
    fixPref: function (pref) {
      this.formData.pref = pref
      this.$emit('form-countup')
    },
    fixWorkplace: function (workplace) {
      this.formData.workplace = workplace
      this.$emit('form-countup')
    },
    setPrefAndWorkplaceAfterForm: function () {
      this.show.nowStatusAndCareer = true
    },
    fixNowStatus: function (nowStatus) {
      this.formData.now_status = nowStatus
      this.$emit('form-countup')
    },
    fixFullTimeWorkerPeriod: function (fullTimeWorkerPeriod) {
      this.formData.full_time_worker_period = fullTimeWorkerPeriod
      this.$emit('form-countup')
    },
    fixCareer: function (career) {
      this.formData.career = career
      this.$emit('form-countup')
    },
    setNowStatusAndCareerAfterForm: function () {
      this.show.birthdayAndGender = true
    },
    fixBirthdayAndGender: function (birthdayAndGender) {
      this.formData.birth_year = birthdayAndGender.birthYear
      this.formData.birth_month = birthdayAndGender.birthMonth
      this.formData.birth_day = birthdayAndGender.birthDay
      this.formData.sex = birthdayAndGender.gender
      this.$emit('form-countup')
    },
    setBirthdayAndGenderAfterForm: function () {
      this.show.nameAndTelAndMail = true
    },
    fixName: function (name) {
      this.formData.name_sei = name.name_sei
      this.formData.name_mei = name.name_mei
      this.formData.kana_sei = name.kana_sei
      this.formData.kana_mei = name.kana_mei
      this.$emit('form-countup')
    },
    fixTelAndMail: function (telAndMail) {
      this.formData.tel1 = telAndMail.tel1
      this.formData.tel2 = telAndMail.tel2
      this.formData.tel3 = telAndMail.tel3
      this.formData.email = telAndMail.email
      this.$emit('form-countup')
    },
    setNameAndTelAndMailAfterForm: function () {
      this.show.password = true
    },
    fixPassword: function (password) {
      this.formData.password = password
      this.$emit('form-countup')
    },
    setPasswordAfterForm: function () {
      this.show.submitbutton = true
    },
    getErrorResponse: function (res) {
      if (res.type === 'other') {
        this.error.message = res.data.message
        this.show.error = true
      } else if (res.type === 'validate') {
        if (res.data) {
          if (res.data.hasOwnProperty('error')) {
            if (res.data.error.hasOwnProperty('email')) {
              if (res.data.error.email.hasOwnProperty('_isUnique')) {
                let RewriteFormComponent = Vue.extend(FormRewriteEmail)
                let rewrite = new RewriteFormComponent()
                rewrite.$mount()
                this.$refs.afterRewrite.appendChild(rewrite.$el)
                rewrite.$on('form-fix-rewrite-email', function (reEmail) {
                  this.formData.email = reEmail
                  let SubmitButtonComponent = Vue.extend(FormSubmitButton)
                  let submitButton = new SubmitButtonComponent({
                    propsData: {
                      formData: this.formData
                    }
                  })
                  submitButton.$mount()
                  this.$refs.afterRewrite.appendChild(submitButton.$el)
                  submitButton.$on('form-error', function (submitFail) {
                    this.getErrorResponse(submitFail)
                  }.bind(this))
                }.bind(this))
              }
            }
          }
        }
      }
    },
    changePref: function (pref) {
      this.formData.pref = pref
    },
    changeWorkplace: function (workplace) {
      this.formData.workplace = workplace
    },
    changeNowStatus: function (nowStatus) {
      this.formData.now_status = nowStatus
    },
    changeFullTimeWorkerPeriod: function (fullTimeWorkerPeriod) {
      this.formData.full_time_worker_period = fullTimeWorkerPeriod
    },
    changeCareer: function (career) {
      this.formData.career = career
    },
    changeBirthdayAndGender: function (birthdayAndGender) {
      this.formData.birth_year = birthdayAndGender.birthYear
      this.formData.birth_month = birthdayAndGender.birthMonth
      this.formData.birth_day = birthdayAndGender.birthDay
      this.formData.sex = birthdayAndGender.gender
    },
    changeName: function (name) {
      this.formData.name_sei = name.name_sei
      this.formData.name_mei = name.name_mei
      this.formData.kana_sei = name.kana_sei
      this.formData.kana_mei = name.kana_mei
    },
    changeTelAndMail: function (telAndMail) {
      this.formData.tel1 = telAndMail.tel1
      this.formData.tel2 = telAndMail.tel2
      this.formData.tel3 = telAndMail.tel3
      this.formData.email = telAndMail.email
    },
    changePassword: function (password) {
      this.formData.password = password
    },
    sendKairosForm: function (customer) {
      this.customer = customer
      this.isKairos = this.constApi.isSend
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChatContents.vue